import initialState from "./initial.value";

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    // =========================
    // LAYOUT
    // =========================
    case "toggle_header":
      return {
        ...state,
        toggle_header: action.payload,
      };

    case "Layoutstyle_data":
      return {
        ...state,
        layoutstyledata: action.payload,
      };

    // =========================
    // AUTH
    // =========================
    case "SET_USUARIO_LOGADO":
      return {
        ...state,
        auth: {
          ...state.auth,
          user: action.payload,
        },
      };

    // =========================
    // ACCESS
    // =========================
    case "SET_ACESSOS":
      return {
        ...state,
        access: {
          ...state.access,
          acessos: action.payload,
        },
      };

    case "SET_ACESSO_ATIVO":
      return {
        ...state,
        access: {
          ...state.access,
          acessoAtivo: action.payload,
        },
      };

    case "SET_PERFIL_ATIVO":
      return {
        ...state,
        access: {
          ...state.access,
          perfilAtivo: action.payload,
        },
      };

    default:
      return state;
  }
};

export default rootReducer;
